import { PlusCircleIcon, UploadIcon } from "@heroicons/react/outline"
import React, { Fragment, useEffect, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { FetchApi } from "../../../api/fetch"
import "react-toastify/dist/ReactToastify.min.css"
import { ActionDialog } from "../../../components/ActionDialog";
import Button from "../../../components/Button";
import CollectionActionForm from "../../../components/CollectionActionForm";
import ImageSelector from "../../../components/ImageSelector";
import { InputField } from "../../../components/InputField";
import { MintHashPreview } from "../../../components/MintHashPreview";
import RequestAlert from "../../../components/RequestAlert";
import { IMAGE_KIT_ENDPOINT_URL, ENDPOINT, Routes } from "../../../constants";
import { useApi } from "../../../contexts/ApiContext";
import { useAuth } from "../../../contexts/AuthContext";
import { ActionType, CollectionState, CollectionStage, Collection } from "../../../types";
import { getIsJson } from "../../../utils/getIsJson";
import { Notification } from "../../../components/Notification"
import { useBlockchain } from "../../../contexts/blockchain";

import { Blockchain } from "../ManageDraft/types";
import { CollectionProps } from "./types"
import {
  requestApproval,
  updateCollection,
} from "./utils"

type ActionNote = {
  buttonText: string
  title: string
  actionType: ActionType
  values?: Values
}

export interface Values {
  walletAddressArray: string[]
  collectionNotes?: string
  collectionName: string
  collectionOwner: string
  collectionId: string
  collectionDescription: string
  websiteLink: string
  twitterLink: string
  teamLink: string
  tiktokLink: string
  instagramLink: string
  mediumLink: string
  roadmapLink: string
  documentationLink: string
  whitepaperLink: string
  discordLink: string
  youtubeLink: string
  isNsfw: boolean
  isDerivative: boolean
  isVerifeyed: boolean | undefined
  isMintCalendar: boolean | undefined
  links: any[]
}

interface ManageCollectionFormParams {
  collectionId: string
}

const ManageCollection = React.memo((props) => {
  const { currentBlockchain }: any = useBlockchain()

  const [mintTab, setMintTab] = useState(0)
  const [actionNote, setActionNote] = useState<ActionNote | undefined>()
  // const [collectionStage, setCollectionStage] = useState<CollectionStage>()
  const [thumbnailFile, setThumbnailFile] = useState()
  const [bannerFile, setBannerFile] = useState()
  const [mintFile, setMintFile] = useState()
  const [hasMintList, setHasMintList] = useState(false)
  const [hasUploadMintList, setHasUploadMintList] = useState(false)
  const [updatedFields, setUpdatedFields] = useState<any[]>()
  const [collectionThumbnail, setCollectionThumbnail] = useState<string>(String)
  const [collectionThumbnailName, setCollectionThumbnailName] =
    useState<string>(String)
  const [collectionThumbnailUrl, setCollectionThumbnailUrl] = useState<string>()
  const [links, setLinks] = useState<any>({ title: "", link: "" })
  const [candyId, setCandyId] = useState("")
  const [collectionData, setCollectionData] = useState<Collection>({
    banner_url: "",
    bannerUrl: "",
    links: [],
    collectionId: "",
    collectionKey: "",
    collection_id: "",
    collection_tag_list: [],
    createdAt: 0,
    creator: "",
    creatorEmail: "",
    creatorNotes: "",
    description: "",
    mintListUrl: "",
    name: "",
    rejectionNote: "",
    request_id: "",
    id: "",
    special_tag_list: [],
    thumbnailUrl: "",
    thumbnail: "",
    updatedAt: 0,
    keys: [],
    candyMachineAddresses: [],
    website: "",
    twitter: "",
    youtube: "",
    discord: "",
    team: "",
    tiktok: "",
    instagram: "",
    medium: "",
    atlas3: "",
    subber: "",
    twitch: "",
    roadmap: "",
    documentation: "",
    whitepaper: "",
    mint_list: [],
    publishedEpoch: 0,
    isDerivative: false,
    isNsfw: false,
    mints: [],
    blockchain: currentBlockchain,
  })


  const [collectionBanner, setCollectionBanner] = useState<string>(String)
  const [collectionBannerName, setCollectionBannerName] =
    useState<string>(String)
  const [collectionBannerUrl, setCollectionBannerUrl] = useState<string>()
  const [mintHashList, setMintHashList] = useState<string[]>([])
  const [mintList] = useState<string[]>([])
  const [mintHashListName, setMintHashListName] = useState<string>(String)
  const [updateNameCheck, setUpdateNameCheck] = useState<string>(String)
  const { uploadFile, } = useApi()

  const {
    currentUser,
    getUserJWT,
    isCurrentUserAdmin,
    setIsLoadingOverlayDisplay,
  } = useAuth()
  const {
    retrieveCollectionsByType
  } = useApi()
  const { push } = useHistory()
  const isAdmin = isCurrentUserAdmin()
  const { collectionId }: ManageCollectionFormParams = useParams()

  const collectionProps = {
    hasMintList,
    mintHashList,
    collectionThumbnail,
    collectionThumbnailUrl,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    mintHashListName,
    collectionBanner,
    collectionBannerUrl,
    getUserJWT,
    currentUser,
    collectionId,
    updateNameCheck,
    collectionEmail: collectionData.creatorEmail,
    hasUploadMintList,
    mintList,
    bannerFile,
    mintFile,
    thumbnailFile,
    uploadFile
  } as CollectionProps

  useEffect(() => {
    document?.getElementById("main")?.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    if (collectionId) {
      (async () => {
        setIsLoadingOverlayDisplay(true)
        let collectionFilter: any = await retrieveCollectionsByType({ id: collectionId }, CollectionState.live, currentBlockchain)

        let collection: Collection = collectionFilter[0]
        if (collection?.state === CollectionState.updated) {
          collectionFilter = await retrieveCollectionsByType({ id: collectionId }, CollectionState.updated, currentBlockchain)
          collectionFilter = await collectionFilter.filter((item: any) => item.id === collectionId)
          if (isAdmin) await compareCollection(collection, collectionFilter[0]);
        }
        collection = collectionFilter[0]

        const dynamicLinks = collection?.links ? JSON.parse(`${collection?.links}`) : []
        setCollectionData({ ...collection, links: dynamicLinks })
        setUpdateNameCheck(collection?.name)
        setHasMintList(Boolean(collection?.mintListUrl))
        // setHasUploadMintList(Boolean(collection?.mintListUrl))


        setIsLoadingOverlayDisplay(false)

        if (collection?.thumbnailUrl?.includes("thumbnails/")) {
          setCollectionThumbnailUrl(
            `${IMAGE_KIT_ENDPOINT_URL}${collection?.thumbnailUrl}`
          )
        } else {
          setCollectionThumbnailUrl(collection?.thumbnailUrl)
        }

        setCollectionBannerUrl(collection?.bannerUrl)


      })()
    }
    setIsLoadingOverlayDisplay(false)

  }, [
    collectionId,
  ])

  const compareCollection = async (oldCol: any, updatedCol: any) => {

    let editedFields = []
    for (const key in oldCol) {
      if (oldCol[key] != updatedCol[key]) {
        if ((key !== "candyMachineAddresses") && (key !== "publishedEpoch") && (key !== "verifeyed") && (key !== "mints")) {
          editedFields.push(key)
        };
        if ((key === "candyMachineAddresses") && (oldCol[key]?.length !== updatedCol[key]?.length)) {
          editedFields.push(key)
        }
      }
    }
    setUpdatedFields(editedFields)
  }

  const onReject = async () => {
    setActionNote({
      buttonText: "SEND REJECTION",
      title: "Rejection notes",
      actionType: ActionType.reject,
    })

  }
  const onDelete = async () => {
    setActionNote({
      buttonText: "DELETE COLLECTION",
      title: "Deletion notes",
      actionType: ActionType.delete,
    })
  }

  const onApprove = async () => {
    setActionNote({
      buttonText: "APPROVE COLLECTION",
      title: "Approval notes",
      actionType: ActionType.approve,
    })
  }
  const respondToCollection = async (
    actionType: ActionType,
    notes: string,
    values?: Values
  ) => {
    setIsLoadingOverlayDisplay(true)
    const JWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token
    const baseUrl = currentBlockchain !== Blockchain.Bitcoin ? ENDPOINT.RESPOND_TO_COLLECTION : ENDPOINT.RESPOND_TO_COLLECTION + "/ordinals"
    const endpoint = collectionData.state === CollectionState.updated ?
      `${ENDPOINT.RESPOND_TO_COLLECTION}/${collectionId}/live_update_response` :
      `${baseUrl}/${collectionId}/verification_response`

    if (actionType === ActionType.reject) {
      let response: any = await FetchApi({
        endpoint,
        method: "POST",
        JWT,
        body:  ({
          rejection_note: notes,
          approve: false,
        }),
      })
      response && setIsLoadingOverlayDisplay(false)
      push(Routes.ADMIN_NOTIFICATIONS)
    }
    if (actionType === ActionType.delete) {
      const baseUrl = currentBlockchain !== Blockchain.Bitcoin ? ENDPOINT.DELETE_LIVE_COLLECTION : ENDPOINT.DELETE_LIVE_COLLECTION + "/ordinals"

      try {
        let response: any = await FetchApi({
          endpoint: `${baseUrl}/${collectionId}`,
          method: "DELETE",
          JWT,
          body:  ({ deletionNotes: notes }),
        })
        response && setIsLoadingOverlayDisplay(false)
        push(Routes.ADMIN_NOTIFICATIONS)
        toast.success(
          <Notification
            title="Collection deleted"
            description="Collection successfully deleted."
          />
        )
      } catch (err) {
        console.log(err)
        toast.error(
          <Notification
            title="Error deleting collection"
            description="Unknown error deleting collection."
          />
        )
      }
    }
    if (actionType === ActionType.approve) {
      await FetchApi({
        endpoint,
        method: "POST",
        JWT,
        body:  ({
          rejection_note: notes,
          approve: true,
        }),
      })
      push(Routes.ADMIN_NOTIFICATIONS)

    }
    setIsLoadingOverlayDisplay(false)
  }
  const handleClose = () => {
    setActionNote(undefined)
  }

  const onUpdateCollection = async (collectionData: any, collectionProps: CollectionProps) => {
    const JWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

    try {
      const response = await updateCollection(collectionData, collectionProps)

      setIsLoadingOverlayDisplay(false)
      if (response?.success) {
        push(isAdmin ? Routes.ADMIN_NOTIFICATIONS : Routes.MANAGE_COLLECTIONS);
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.log(error)
    }

  };
  const requestVerification = async (collectionData: any, collectionProps: CollectionProps) => {
    const response = await requestApproval(collectionData, collectionProps)
    response && setIsLoadingOverlayDisplay(false)
    if (response?.success) {
      push(Routes.MANAGE_COLLECTIONS)
    } else {
      toast.error(response.message)
    }

  }

  const onSelectCollectionBanner = () => {
    setTimeout(() => {
      document?.getElementById("collectionBannerSelector")?.click()
    }, 0)
  }

  const handleCollectionBannerSelected = (event: any) => {
    const reader = new FileReader()
    const file = event?.target?.files && event?.target?.files[0]
    if (file) {
      setBannerFile(file)
      reader.onloadend = () => {
        setCollectionBanner(reader?.result as string)
        setCollectionBannerName(`${file.name}`)
        // setCollectionBannerName(`${BANNER_FILE_NAME}.${extension(file.type)}`)
      }
      reader.readAsDataURL(file as Blob)
    }
  }
  const onSelectCollectionThumbnail = () => {
    setTimeout(() => {
      document?.getElementById("collectionThumbnailSelector")?.click()
    }, 0)
  }

  const handleCollectionThumbnailSelected = (event: any) => {
    const reader = new FileReader()
    const file = event?.target?.files && event?.target?.files[0]
    if (file) {
      setThumbnailFile(file)
      reader.onloadend = () => {
        setCollectionThumbnail(reader?.result as string)
        setCollectionThumbnailName(
          `${file.name}`
          // `${THUMBNAIL_FILE_NAME}.${extension(file.type)}`
        )
      }
      reader.readAsDataURL(file as Blob)
    }
  }

  const onSelectMintHashList = () => {
    setTimeout(() => {
      document?.getElementById("mintHashListSelector")?.click()
      setHasUploadMintList(true)
    }, 0)
  }

  const handleMintHashListSelector = (event: any) => {
    const reader = new FileReader()
    const file = event?.target?.files && event?.target?.files[0]
    if (file) {
      setMintFile(file)
      reader.onloadend = () => {
        if (getIsJson(reader?.result as string)) {
          setMintHashListName(file.name)
          setMintHashList(JSON.parse(reader?.result as string))
        } else {
          toast.error(
            <Notification
              title="Invalid file"
              description="The Json file provided is either not a Json file or is not formatted correctly."
            />
          )
        }
      }
      reader.readAsText(file)
    }
  }

  const deleteLink = (elem: any) => {
    setCollectionData({
      ...collectionData,
      links: collectionData?.links.filter((item) => item.title !== elem.title)
    })
  }
  const addLink = () => {
    const isExisting = collectionData?.links.filter((item) => item.title === links?.title)
    if (isExisting?.length > 0) {
      toast.warning("Link already exists");
      return
    } else if (links.title === "" || links.link === "") {
      toast.warning("invalid link");
      return
    } else {
      setCollectionData({
        ...collectionData,
        links: [...collectionData?.links, links]
      })
      setLinks({ title: "", link: "" })
    }

  }
  const handleLinkChange = (e: any) => {
    setLinks({
      ...links,
      [e.target.name]: e.target.value
    })
  }
  const deleteCandyId = (elem: any) => {
    setCollectionData({
      ...collectionData,
      candyMachineAddresses: collectionData?.candyMachineAddresses?.filter((item) => item !== elem)
    })
  }
  const addCandyId = () => {
    const isExisting = collectionData?.candyMachineAddresses?.filter((item) => item === candyId)
    if (isExisting && isExisting?.length > 0) {
      toast.warning("Candy Machine Id already exists");
      return
    } else if (candyId === "") {
      toast.warning("invalid candy machine id");
      return
    } else {
      setCollectionData({
        ...collectionData,
        candyMachineAddresses: collectionData?.candyMachineAddresses ? [...collectionData?.candyMachineAddresses, candyId] : [candyId]
      })
      setCandyId("")
    }

  }
  const handleCandyIdChange = (e: any) => {
    setCandyId(e.target.value)
  }

  const handleChange = (e: any) => {
    if (e.target.name === "blockchain") {
      setMintTab(0)
    }
    setCollectionData({
      ...collectionData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value
    })
  }
  return (
    <>
      <div className="flex flex-col w-11/12 mx-auto pb-2">
        <div className="mt-8 flex flex-row items-start mb-8 justify-between flex-col sm:flex-row">
          <div className="mb-1 sm:mb-0">
            {collectionId && <RequestAlert stage={CollectionStage.live} />}
            <h1 className="font-medium text-3xl text-left mt-8 mb-8">
              MANAGE COLLECTION
            </h1>
          </div>
          <div className="w-full sm:w-auto flex items-center space-x-4">

            {isAdmin && (
              <>
                <Button
                  type="button"
                  className="mb-0 sm:mb-2 btn btn-gray"
                  onClick={onDelete}
                >
                  DELETE
                </Button>

                {((collectionData.state === CollectionState.pending) || (collectionData.state === CollectionState.updated)) && (
                  <>
                    <Button
                      type="button"
                      className="mb-0 sm:mb-2 btn btn-green"
                      onClick={onApprove}
                    >
                      APPROVE
                    </Button>

                    <Button
                      type="button"
                      className="mb-0 sm:mb-2 btn btn-gray"
                      onClick={onReject}
                    >
                      REJECT
                    </Button>
                  </>
                )}
              </>
            )}
            {
              !isAdmin && (collectionData.state === CollectionState.rejected) &&
              <Fragment>
                <Button
                  type="button"
                  className="mb-0 sm:mb-2 btn btn-green"
                  onClick={() => { collectionData.candyMachineAddresses.length > 0 || collectionData.mintListUrl || hasUploadMintList ? requestVerification(collectionData, collectionProps) : toast.error("please add a mint list") }}
                >
                  Request Approval
                </Button>
              </Fragment>
            }
          </div>
        </div>
        <div className="mb-1">
          {
            isAdmin && collectionData.state === CollectionState.updated && (
              <Fragment>
                <h1>UPDATED FIELDS</h1>
                <ul className="text-gray-500">
                  {
                    updatedFields?.map((field: string, ind: number) => (
                      <li key={ind}>- {field}</li>
                    ))
                  }
                </ul>
              </Fragment>
            )
          }
        </div>
        <form
          onSubmit={(e) => { e.preventDefault(); onUpdateCollection(collectionData, collectionProps) }}
          className="flex flex-auto flex-col "
        >
          <h2 className="mb-4 text-left gradient-text">COLLECTION INFORMATION</h2>
          {isAdmin && (
            <InputField
              onChange={handleChange}
              value={collectionData.creatorEmail}
              name="creatorEmail"
              label="Collection owner"
            // disabled
            />
          )}
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-2 lg:gap-3 w-full">
            <InputField
              onChange={handleChange}
              value={collectionData?.name}
              required={true}
              name="name"
              label="Collection Name"
            />
            <div className="mb-4">
              <label className="inline-block text-sm font-base text-gray-300 mb-2 w-5/6 mr-0">
                Blockchain
              </label>
              <select required name="blockchain" className="bg-transparent text-left text-gray-40 placeholder-gray-600 border-2 rounded-lg w-full px-4 py-3 border-kyzzen-secondary read-only:opacity-50" disabled value={currentBlockchain} >
                <option className="bg-black text-sm text-gray-200" style={{ color: "white" }} value={""}>Select Blockchain</option>
                <option className="bg-black text-sm text-gray-200" style={{ color: "white" }} value={Blockchain.Solana}>Solana</option>
                <option className="bg-black text-sm text-gray-200" style={{ color: "white" }} value={Blockchain.Bitcoin}>Bitcoin Ordinal</option>
              </select>
            </div>
          </div>
          <InputField
            onChange={handleChange}
            value={collectionData?.description}
            name="description"
            label="Collection Description"
            required={true}
          />
          <h2 className="my-4 text-left gradient-text">SOCIAL MEDIA AND WEBSITES</h2>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-2 lg:gap-3 w-full">
            <InputField
              onChange={handleChange}
              value={collectionData?.website}
              name="website"
              label="Website Link"
              required={!isAdmin}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.discord}
              name="discord"
              label="Discord URL"
              placeholder="eg: https://discord.gg/56PDke6E"
              required={!isAdmin}
              className={`outline-none border border-2 ${(!collectionData?.discord?.includes("discord.gg") && !collectionData?.discord?.includes("discord.com")) && collectionData?.discord ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean((!collectionData?.discord?.includes("discord.gg") && !collectionData?.discord?.includes("discord.com")) && collectionData?.discord),
                text: "please provide a valid discord url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.twitter}
              name="twitter"
              label="Twitter / X URL"
              placeholder="eg: https://twitter.com/KyzzenNFT"
              required={!isAdmin}
              className={`outline-none border border-2 ${!(collectionData?.twitter?.includes("twitter.com") || collectionData?.twitter?.includes("x.com")) && collectionData?.twitter ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!(collectionData?.twitter?.includes("twitter.com") || collectionData?.twitter?.includes("x.com")) && collectionData?.twitter),
                text: "please provide a valid Twitter / X URL"
              }}
            />

            <InputField
              onChange={handleChange}
              value={collectionData?.instagram}
              name="instagram"
              label="Instagram URL"
              placeholder="eg: https://instagram.com/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.instagram?.includes("instagram.com") && collectionData?.instagram ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.instagram?.includes("instagram.com") && collectionData?.instagram),
                text: "please provide a valid instagram url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.tiktok}
              name="tiktok"
              label="Tiktok URL"
              placeholder="eg: https://tiktok.com/@KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.tiktok?.includes("tiktok.com") && collectionData?.tiktok ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.tiktok?.includes("tiktok.com") && collectionData?.tiktok),
                text: "please provide a valid tiktok url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.youtube}
              name="youtube"
              label="YouTube URL"
              placeholder="eg: https://youtube.com/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.youtube?.includes("youtube.com") && collectionData?.youtube ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.youtube?.includes("youtube.com") && collectionData?.youtube),
                text: "please provide a valid youtube url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.twitch}
              name="twitch"
              label="Twitch URL"
              placeholder="eg: https://twitch.tv/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.twitch?.includes("twitch.tv") && collectionData?.twitch ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.twitch?.includes("twitch.tv") && collectionData?.twitch),
                text: "please provide a valid twitch url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.medium}
              name="medium"
              label="Medium URL"
              placeholder="eg: https://medium.com/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.medium?.includes("medium.com") && collectionData?.medium ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.medium?.includes("medium.com") && collectionData?.medium),
                text: "please provide a valid medium url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.atlas3}
              name="atlas3"
              label="Atlas3 URL"
              placeholder="eg: https://atlas3.io/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.atlas3?.includes("atlas3.io") && collectionData?.atlas3 ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.atlas3?.includes("atlas3.io") && collectionData?.atlas3),
                text: "please provide a valid atlas url"
              }}
            />
            <InputField
              onChange={handleChange}
              value={collectionData?.subber}
              name="subber"
              label="Subber URL"
              placeholder="eg: https://subber.xyz/KyzzenNFT"
              className={`outline-none border border-2 ${!collectionData?.subber?.includes("subber.xyz") && collectionData?.subber ?
                "border-red-600" : "border-gray-600"
                }`}
              warning={{
                isVisible: Boolean(!collectionData?.subber?.includes("subber.xyz") && collectionData?.subber),
                text: "please provide a valid subber url"
              }}
            />


          </div>

          <h2 className="my-4 text-left gradient-text">CUSTOM LINKS</h2>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-2 lg:gap-3 w-full">

            {
              collectionData?.links?.map((item, idx) => (
                <div className="relative" key={idx}>
                  <InputField
                    value={item.link}
                    name="links"
                    label={item.title}
                    placeholder="eg: https://example.com"
                    readOnly
                    className=" bg-gray-900"
                    deleteField={() => deleteLink(item)}
                  />
                </div>
              ))
            }
          </div>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-2 lg:gap-3 w-full">
            <InputField
              onChange={handleLinkChange}
              value={links.title}
              name={`title`}
              label="Link Title"
              className="w-4/12 mr-2"
            />
            <InputField
              onChange={handleLinkChange}
              value={links.link}
              name={`link`}
              label="Link Url"
              className="w-4/12 "
            />
          </div>
          <div className="m-auto">
            <Button
              type="button"
              className="btn bg-gradient text-kyzzen-primary font-medium mb-2 mx-0 h-12 flex items-center border-box"
              onClick={addLink}
            >
              Add Custom Link
              <PlusCircleIcon className="h-5 inline ml-2" />
            </Button>
          </div>

          {
            <>
              <div className="flex justify-center">
                <Button
                  className="mb-8 mt-10 btn-tab flex items-center"
                  onClick={() => {
                    setMintTab(0)
                    setHasMintList(true)
                  }}
                  disabled={mintTab === 0}
                >
                  <PlusCircleIcon className="h-5 inline mr-2" />
                  Add Mint List
                </Button>
                {
                  currentBlockchain !== Blockchain.Bitcoin &&
                  <>
                    <Button
                      className="mb-8 mt-10 btn-tab flex items-center"
                      onClick={() => {
                        setMintTab(1)
                        setHasMintList(false)
                      }}
                      disabled={mintTab === 1}
                    >
                      <PlusCircleIcon className="h-5 inline mr-2" />
                      Add Collection Key
                    </Button>
                    <Button
                      className="mb-8 mt-10 btn-tab flex items-center"
                      onClick={() => {
                        setMintTab(2)
                        setHasMintList(false)
                      }}
                      disabled={mintTab === 2}
                    >
                      <PlusCircleIcon className="h-5 inline mr-2" />
                      Add Candy Machine ID
                    </Button>
                  </>
                }


              </div>
              {mintTab === 1 ? (
                <div className="flex flex-col w-full">
                  <div className="pt-1 w-full flex">
                    <InputField
                      value={collectionData?.collectionKey}
                      name={`collectionKey`}
                      className="w-full mr-2 my-0 mb-0"
                      placeholder="Enter Collection Key"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              ) : mintTab === 2 ? (
                <div className="flex flex-col w-full">
                  {collectionData?.candyMachineAddresses?.map((d, idx) => {
                    return (
                      <div key={idx} className="pt-1 flex">
                        <InputField
                          value={d}
                          name="candyMachineAddresses"
                          readOnly
                          disabled={true}
                          className=" bg-gray-900"
                        />
                        {
                          ((collectionData?.candyMachineAddresses && collectionData?.candyMachineAddresses?.length > 1) || collectionData?.mintListUrl) &&
                          <Button
                            type="button"
                            className="btn btn-danger bg-gray-700 mb-2 ml-2 px-4 h-12"
                            onClick={() => deleteCandyId(d)}
                          >
                            Delete
                          </Button>
                        }

                      </div>
                    )
                  })}
                  <div className="flex flex-row w-full ">
                    <div className="pt-1 w-full flex">
                      <InputField
                        onChange={handleCandyIdChange}
                        value={candyId}
                        name={`title`}
                        className="w-full mr-2 my-0 mb-0"
                        placeholder="Enter Candy Machine Id"
                      />
                      <div className="w-4"></div>
                      <Button
                        type="button"
                        className=" btn w-60 h-12 py-0 my-0 rounded-md bg-gradient text-kyzzen-primary  text-center font-medium flex items-center"
                        onClick={addCandyId}
                      >
                        Click To Add
                        <PlusCircleIcon className="h-5 inline ml-2" />
                      </Button>
                    </div>

                  </div>
                </div>
              ) : (
                <>
                  <div className="flex flex-col items-center justify-center space-y-4 w-full mt-2">
                    <input
                      style={{ display: "none" }}
                      type="file"
                      accept="application/json"
                      id="mintHashListSelector"
                      onChange={handleMintHashListSelector}
                    />
                    <Button
                      type="button"
                      // disabled={isSubmitting}
                      className="btn flex flex-row items-center"
                      onClick={onSelectMintHashList}
                    >
                      <span>UPLOAD MINT LIST</span>{" "}
                      <UploadIcon className="h-6 w-6 ml-4" />
                    </Button>
                    {mintHashListName && (
                      <div className="text-lg p-2 text-gray-800 bg-gray-200 mr-4 w-full text-left">
                        {mintHashListName}
                      </div>
                    )}
                    {
                      collectionData.mintListUrl &&
                      <div className="text-lg p-2 text-gray-800 bg-gray-200 mr-4 w-full text-left">
                        MintList.json
                      </div>
                    }
                  </div>

                  {/* {
                    mintList && mintList?.length > 0 &&
                    <div className="flex-column text-center mt-8 mb-5">
                      <span className="text-lg">
                        Choose what to do with your mint list.
                      </span>
                      <div className="flex justify-center space-x-2">
                        <Button
                          className={`${isReplaceMintList ||
                            isReplaceMintList === undefined
                            ? "bg-gray-700"
                            : "bg-transparent opacity-50"
                            } px-4 py-2 rounded-md mt-2 border-gray-700 border-2 hover:bg-gray-700`}
                          onClick={() => setIsReplaceMintList(true)}
                          disabled={isReplaceMintList}
                        >
                          Replace current mint list
                        </Button>
                        <Button
                          className={`${!isReplaceMintList
                            ? "bg-gray-700"
                            : "bg-transparent opacity-50"
                            } px-4 py-2 rounded-md mt-2 border-gray-700 border-2 hover:bg-gray-700`}
                          onClick={() => setIsReplaceMintList(false)}
                          disabled={isReplaceMintList === false}
                        >
                          Add to current mint list
                        </Button>
                      </div>
                    </div>
                  } */}
                </>
              )}
            </>
          }

          {
            // collectionStage === CollectionStage.live &&
            <div className="flex justify-center ">
              {collectionId && <MintHashPreview collection={collectionData} id={collectionId} />}

            </div>
          }
          {/* 
          {!collectionId &&
            <div className="p-4 text-gray-600 text-light text-md"
            >
              {`Upload your collection to download the mints list as a .json file`}
            </div>
          } */}
          {/* {collectionStage && mintList.length < 1 &&
                <div className="p-4 text-gray-600 text-light text-md"
                >
                  {`Your collection has 0 mints. JSON file unavailable`}
                </div>
              } */}

          <div className="w-full mx-auto mb-8 mt-8">
            <input
              style={{ display: "none" }}
              type="file"
              accept=".png, .jpg, .jpeg, .gif"
              id="collectionBannerSelector"
              onChange={handleCollectionBannerSelected}
            />
            <input
              style={{ display: "none" }}
              type="file"
              accept=".png, .jpg, .jpeg, .gif"
              id="collectionThumbnailSelector"
              onChange={handleCollectionThumbnailSelected}
            />
            <ImageSelector
              imageSrc={
                Boolean(collectionData.bannerUrl && !collectionBanner)
                  ? collectionData.bannerUrl
                  : collectionBanner
              }
              iconSrc={
                Boolean(collectionData.thumbnailUrl && !collectionThumbnail)
                  ? collectionData.thumbnailUrl
                  : collectionThumbnail
              }
              onSelectImage={onSelectCollectionBanner}
              onSelectIcon={onSelectCollectionThumbnail}
            />
          </div>
          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                onChange={handleChange}
                type="checkbox"
                checked={collectionData?.isNsfw}
                disabled={!isAdmin}
                name="isNsfw"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">NSFW Collection</label>
          </div>
          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                onChange={handleChange}
                type="checkbox"
                checked={collectionData?.isDerivative}
                disabled={!isAdmin}
                name="isDerivative"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">Derivative Collection</label>
          </div>

          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                onChange={handleChange}
                type="checkbox"
                checked={collectionData?.verifeyed}
                disabled={!isAdmin}
                name="verifeyed"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">Verifeyed Collection</label>

          </div>

          {collectionId && (
            <div className="flex justify-center my-5">

              <Button
                className="m-3 btn bg-gradient text-kyzzen-primary font-medium"
                type="button"
                onClick={() => onUpdateCollection(collectionData, collectionProps)}
              >
                Update collection
              </Button>

              <Button
                className="m-3 btn bg-kyzzen-primary border border-gray-70 text-gray-70 font-medium"
                type="button"
                onClick={() =>
                  window.open(
                    `https://kyzzen.io/collections/${collectionData?.name}`,
                    "_blank"
                  )
                }
                disabled={
                  collectionData?.mints && collectionData?.mints?.length === 0
                }
              >
                {!collectionId || (collectionData?.mints && collectionData?.mints?.length > 0)
                  ? "Preview collection "
                  : "Preview unavailable without mint items"}
              </Button>
            </div>
          )}

        </form>
        {actionNote && (
          <ActionDialog
            isOpen={!!actionNote}
            onCloseClick={handleClose}
            heading={actionNote.title}
          >
            <CollectionActionForm
              actionButtonText={actionNote.buttonText}
              actionType={actionNote.actionType}
              values={actionNote?.values}
              onSubmit={respondToCollection}
            />
          </ActionDialog>
        )}
      </div>
    </>
  )
})

export default ManageCollection





